/*
 * @Author: your name
 * @Date: 2020-08-13 10:48:37
 * @LastEditTime: 2020-10-30 13:41:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \qh-wbwebsite\src\router\index.js
 */
import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/layout';
Vue.use(Router);

export default new Router({
    scrollBehavior: () => ({ y: 0 }),
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Layout,
            redirect: '/index',
            meta: {
                title: '首页',
            },
            children: [
                {
                    path: 'index',
                    component: () => import('@/views/index/index'),
                    meta: { title: '首页' },
                },
                {
                    path: 'intro',
                    component: () =>
                        import('@/views/companyIntroduction/index'),
                    meta: { title: '公司简介' },
                },
                {
                    path: 'events',
                    component: () =>
                        import('@/views/companyIntroduction/coreEvents'),
                    meta: { title: '大事记' },
                },
                {
                    path: 'products',
                    component: () => import('@/views/coreProducts/index'),
                    meta: { title: '核心产品' },
                },
                {
                    path: 'resource',
                    component: () => import('@/views/coreResource/index'),
                    meta: { title: '核心资源' },
                },
                {
                    path: 'mall',
                    component: () => import('@/views/mall/index'),
                    meta: { title: '文创商城' },
                },
                {
                    path: 'news',
                    component: () => import('@/views/news/newsList'),
                    meta: { title: '新闻动态' },
                },
                {
                    path: 'news/detail',
                    component: () => import('@/views/news/newsDetail'),
                    meta: { title: '新闻详情' },
                },
                {
                    path: 'contact',
                    component: () => import('@/views/contactUs/index'),
                    meta: { title: '联系我们' },
                },
                {
                    path: 'certificate/telecom',
                    component: () => import('@/views/certificate/telecom'),
                    meta: { title: '增值电信业务经营许可证' },
                },
                {
                    path: 'certificate/cultureManage',
                    component: () => import('@/views/certificate/culture'),
                    meta: { title: '网络文化经营许可证' },
                },
            ],
        },
        {
            path: '/dunhuang',
            name: 'dunhuang',
            meta: {
                title: '敦煌文创',
            },
            component: () => import('@/views/dunhuang/index'),
        },
        {
            path: '/excellentCourses',
            name: 'excellentCourses',
            meta: {
                title: '精品课程',
            },
            component: () => import('@/views/excellentCourses/index'),
        },
        {
            path: '/excellentCourses/getProcess',
            name: 'coursesGetProcess',
            meta: {
                title: '精品课程获取流程',
            },
            component: () => import('@/views/excellentCourses/getProcess'),
        },
        {
            path: '/zhongqiu2021',
            name: 'midAutumn',
            meta: {
                title: '敦煌中秋礼盒',
            },
            component: () => import('@/views/midAutumn/index'),
        },
        {
            path: '/404',
            name: 'error',
            meta: {
                title: 'error',
            },
            component: () => import('@/views/errorPage/404'),
        },
        {
            path: '*',
            redirect: '/404',
            name: '404',
            hidden: true,
            meta: {
                title: '404',
            },
        },
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js